export function getUpdatedPeriodData(
  apiPrams,
  periodIndex,
  value,
  selectedPeriod,
) {
  const payload = {
    ticker: this.ticker,
    period: [
      {
        position: periodIndex,
        rolling_period: `${value}${selectedPeriod}`,
      },
    ],
  };
  this.dataService.updateLIMPeriod(payload).subscribe((response) => {
    const selectedHeader = response.data.period[0];
    this.lineItemsMeta.period_list[periodIndex] = response.data.period[0];
    this.lineItemsMeta.chart_estimated_period = response.data.period[0];
    this.lineItemsMeta.relative_periods[periodIndex] =
      `${value}${selectedPeriod}`;
    const level1headers = [...this.gridHeader.level1];
    level1headers[periodIndex + 1].label = selectedHeader;
    this.gridHeader.level1 = level1headers;
    const payload = {
      ticker: this.ticker,
      param_ids: this.lineItemsMeta.line_items.map(
        (line) => line.dapparameterid,
      ),
      period: [response.data.period[0]],
      ...apiPrams,
    };
    this.updatePeriod.emit([this.lineItemsMeta]);
    this.getPeriodData({ ...payload });
  });
}
